"use client"

import { AuthGuard } from "@/components/admin/AuthGuard"
import { LogoutButton } from "@/components/admin/LogoutButton"

export function AdminLayoutClient({ children }: { children: React.ReactNode }) {
  return (
    <AuthGuard>
      <div className="min-h-screen bg-bg">
        <header className="bg-white border-b border-border">
          <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
            <h1 className="text-xl font-bold text-text">Specledger Admin</h1>
            <LogoutButton />
          </div>
        </header>
        <main className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {children}
        </main>
      </div>
    </AuthGuard>
  )
}
